import { render, staticRenderFns } from "./CommonMultiselect.vue?vue&type=template&id=545b8fc0"
import script from "./CommonMultiselect.vue?vue&type=script&lang=js"
export * from "./CommonMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545b8fc0')) {
      api.createRecord('545b8fc0', component.options)
    } else {
      api.reload('545b8fc0', component.options)
    }
    module.hot.accept("./CommonMultiselect.vue?vue&type=template&id=545b8fc0", function () {
      api.rerender('545b8fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/CommonMultiselect.vue"
export default component.exports